export const TARGETS = {
  SELECTED_TASKS: 'selectedTasks',
  TASK: 'task',
  DELETE_TASK: 'deleteTask',
  WORKSPACE_TASKS: 'workspaceTasks'
};
